import { render } from "./comment_panel.vue?vue&type=template&id=35d07386"
import script from "./comment_panel.vue?vue&type=script&lang=js"
export * from "./comment_panel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/comment_panel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35d07386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35d07386', __exports__)) {
    api.reload('35d07386', __exports__)
  }
  
  module.hot.accept("./comment_panel.vue?vue&type=template&id=35d07386", () => {
    api.rerender('35d07386', render)
  })

}


export default __exports__